import { styled } from 'styled-components'
import { ReactComponent as TrustPilotLogoSvg } from '../../images/homePage/trustpilot-logo.svg'
import { ReactComponent as ReviewStars } from '../../images/homePage/review-stars.svg'

export const ReviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  font-size: 14px;
  font-weight: 500;
`

export const TextWrapper = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  white-space: nowrap;
`

export const TrustPilotLogo = styled(TrustPilotLogoSvg)`
  transform: translateY(-3px);
`

export const VSeparator = styled.div`
  width: 1px;
  height: 9px;
  opacity: 0.2;
  background: ${({ theme }) => theme.colors.black};
`

export const ReviewScore = styled.span``

export const ReviewStarsSvg = styled(ReviewStars)`
  width: 85px;
  height: 17px;
`
